"use client";

import { useI18n } from "@wojo/localization";

export const useValidSlug = (
    slug: string,
): readonly [ValidMvpSlug, string] | undefined => {
    const account = useI18n("account").account;
    const navigation = account.navigation.booking;
    const mvpCopyDict = account.mvpPages.pages;
    const camelCaseSlug = slug.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    const supportedSlugs: ValidMvpSlug[] = Object.keys(
        mvpCopyDict,
    ) as ValidMvpSlug[];

    return supportedSlugs
        .filter((thisSlug) => camelCaseSlug === thisSlug)
        .map((slug: ValidMvpSlug) =>
            navigation[slug] !== undefined
                ? // TypeScript < 5.5 does not catch the comparison above which is why we need the `!`
                  ([slug, navigation[slug]!.text.l()] as const)
                : undefined,
        )
        .at(0);
};

export type ValidMvpSlug = keyof ReturnType<
    typeof useI18n<"account">
>["account"]["mvpPages"]["pages"];
